import React, { Component } from 'react';
import DrawerLeft from './DrawerLeft/DrawerLeft';
import withStyles from '@material-ui/core/styles/withStyles';
import BackOfficeHeader from './BackOfficeHeader';

const styles = theme => ({
  childrenContainer: {
    margin: '20px 40px',
    [theme.breakpoints.down('md')]: {
      margin: 20,
    },
    [theme.breakpoints.down('xs')]: {
      margin: '10px 0',
    },
  },
  layout: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 2,
  },
});

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
    };
  }

  handleDrawerToggle = value => {
    if (value !== undefined) {
      this.setState({ mobileOpen: value });
    } else {
      this.setState(prevState => ({ mobileOpen: !prevState.mobileOpen }));
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div style={{ display: 'flex' }}>
        <DrawerLeft
          history={this.props.history}
          mobileOpen={this.state.mobileOpen}
          handleDrawerToggle={this.handleDrawerToggle}
        />
        <div className={classes.layout}>
          <BackOfficeHeader
            title="BackOffice"
            handleDrawerToggle={this.handleDrawerToggle}
            handleProfileClick={this.handleProfileClick}
            history={this.props.history}
          />
          <div className={classes.childrenContainer}>{this.props.children}</div>
        </div>
      </div>
    );
  }
}
export default withStyles(styles)(Layout);
